import { Box, Center, useDisclosure } from '@chakra-ui/react';
import useAccountIdQueryParam from 'hooks/modules/brokerAccount/useAccountIdQueryParam';
import usePeriodQueryParam from 'hooks/modules/period/usePeriodQueryParam';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import { FC } from 'react';
import { useFetchHomeQuery } from 'rtkQuery/sharespro/queries/home';
import HomeRebalancingCard from 'presentation/components/modules/home/HomeRebalancingCard';
import ConfirmAllRebalancingModal from 'presentation/containers/modules/orders/ConfirmAllRebalancingModal';

const HomeRebalancingContainer: FC = () => {
  const [accountId] = useAccountIdQueryParam();
  const [period] = usePeriodQueryParam();
  const { data, error, refetch } = useFetchHomeQuery({
    period,
    account_id: accountId,
  });

  const {
    isOpen: isConfirmationModalOpen,
    onOpen: openConfirmationModal,
    onClose: closeConfirmationModal,
  } = useDisclosure();

  const rebalanceAccount = data
    ? data.accounts.items.find(
        (e) =>
          e.rebalancing !== null && e.rebalancing?.recommendations.length !== 0
      )
    : null;
  const showCard = rebalanceAccount
    ? accountId
      ? rebalanceAccount.id === accountId
        ? true
        : false
      : true
    : false;

  const wrapByCard = !data;
  let content;
  if (showCard && rebalanceAccount) {
    content = (
      <>
        <HomeRebalancingCard
          rebalancing={rebalanceAccount.rebalancing}
          onApproveClicked={openConfirmationModal}
        />
        <ConfirmAllRebalancingModal
          isOpen={isConfirmationModalOpen}
          onClose={closeConfirmationModal}
          id={rebalanceAccount.rebalancing!.id}
        />
      </>
    );
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  }

  if (!content) {
    return null;
  }

  if (wrapByCard) {
    content = (
      <AppCard p="20">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return <Box mb="20px">{content}</Box>;
};

export default HomeRebalancingContainer;
